import vPage from "./index.vue";

export default vPage;
